import React from 'react'
import { Helmet } from 'react-helmet-async'
import { BsWhatsapp, BsInstagram, BsFillTelephoneFill } from 'react-icons/bs'
import { GrFacebook, GrMail } from 'react-icons/gr'


export default function ContactUs() {
  return (
    <>
      <Helmet>
      <title>Contact Us - IlmUlQuran Online Academy</title>

        <link rel="canonical" href="https://www.ilmulquran.online/contactUs" />
        <meta name="description" content="Contact IlmUlQuran Online Academy with your questions and feedback. We value your input. Get in touch with our team today."/>
        <meta property="og:url" content="https://ilmulquran.online/contactUs"/>



      </Helmet>
      <div className="mt-12">

        <h1 className="text-center text-[#fffa8a] font-bold text-[48px] p-10 underline">Contact Us</h1>
        <div>
          <section className="text-gray-600 body-font">
            <div className="container px-5 py-18 mx-auto">
              <div className="flex flex-wrap -m-4">
                <div className="p-4 md:w-1/3 w-[90%]  mx-auto">
                  <div className="h-full border-2 border-[#fffa8a] border-opacity-60 rounded-lg overflow-hidden contactUSEffect">
                    <a href='https://wa.me/923204658316' target='blank'>
                      <BsWhatsapp className="text-[150px] mx-auto my-6  text-[#fffa8a]" />
                      <h4 className='font-bold text-xl text-center underline text-[#fffa8a] py-4 px-4'>Chat with Us on WhatsApp</h4>
                      <p className='text-xl text-center text-[#fffa8a] italic py-4'>+923204658316</p>
                    </a>
                  </div>
                </div>
                <div className="p-4 w-[90%] md:w-1/3 mx-auto">
                  <div className="h-full border-2 border-[#fffa8a] border-opacity-60 rounded-lg overflow-hidden contactUSEffect">
                    <a href='https://instagram.com/ilm_ul_quran__online_academy?igshid=MzRlODBiNWFlZA==' target='blank'>
                      <BsInstagram className="text-[150px] mx-auto my-6  text-[#fffa8a]" />
                      <h4 className='px-4 font-bold text-xl text-center underline text-[#fffa8a] py-4'>Connect with Us on Instagram</h4>
                      <p className='text-xl text-center text-[#fffa8a] italic py-4'>ilm_ul_quran__online_academy</p>
                    </a>
                  </div>
                </div>
                <div className="p-4 w-[90%] md:w-1/3 mx-auto">
                  <div className="h-full border-2 border-[#fffa8a] border-opacity-60 rounded-lg overflow-hidden contactUSEffect">
                    <a href='https://www.facebook.com/people/IlmUlQuran-online-Quran-academy/61550485307632/?mibextid=ZbWKwL' target='blank'>
                      <GrFacebook className="text-[150px] mx-auto my-6  text-[#fffa8a]" />
                      <h4 className='font-bold text-xl text-center underline px-4 text-[#fffa8a] py-4'>Connect with Us on Facebook</h4>
                      <p className='text-xl text-center text-[#fffa8a] italic py-4'>Ilm Ul Quran online Quran academy</p>
                    </a>
                  </div>
                </div>
                <div className="p-4 w-[90%] md:w-1/3 mx-auto">
                  <div className="h-full border-2 border-[#fffa8a] border-opacity-60 rounded-lg overflow-hidden contactUSEffect">
                    <a href='tel:+923204658316' target='blank'>
                      <BsFillTelephoneFill className="text-[150px] mx-auto my-6  text-[#fffa8a]" />
                      <h4 className='font-bold text-xl text-center underline px-4 text-[#fffa8a] py-4'>Call Us Now</h4>
                      <p className='text-xl text-center text-[#fffa8a] italic py-4'>+923204658316</p>
                    </a>
                  </div>
                </div>
                <div className="p-4 w-[90%] md:w-1/3 mx-auto">
                  <div className="h-full border-2 border-[#fffa8a] border-opacity-60 rounded-lg overflow-hidden contactUSEffect">
                    <a href='mailto:ilmulquran762@gmail.com@gamil.com' target='blank'>
                      <GrMail className="text-[150px] mx-auto my-6  text-[#fffa8a]" />
                      <h4 className='font-bold text-xl text-center underline px-4 text-[#fffa8a] py-4'>Get in Touch via Email</h4>
                      <p className='text-xl text-center text-[#fffa8a] italic py-4'>ilmulquran762@gmail.com</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>   </>
  )
}
